import ArticleTemplate from "../components/ArticleTemplate";
import { articles } from "@/mocks/articles";

export default function ArticleJakKorzystac() {
  return <ArticleTemplate article={articles[1]} />;
}